import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'

import { UserStore } from 'app/store/user.store'

export const isAdminGuard: CanActivateFn = () => {
  const userStore = inject(UserStore)
  return userStore.isAdmin()
}
